import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

// ******* components *******
import { SidePopup } from "../../../components/model-popup/side-popup";
import { CustomButton } from "../../../components/buttons/button";
import TextIconInput from "../../../components/custom-fields/input";
import Table from "../../../components/table/table";
import { ConfirmPopup } from "../../../components/model-popup/confirmation-popup";


// ******* utils *******
import { WordTitle } from "../../../utils/commonFunction";
import { toast} from "react-toastify";

// ******* assets *******
import SearchIcon from "../../../assets/icons/search-icon.svg";


// ******* api *******
import { fetchSearchPatientList } from "../../../redux/slices/patientlookup.slice";
import { UpdateNotesErrorByPatientDetailsAPI } from "../../../api/update";
import { getPatientIdList } from "../../../api/list";

export const IncompletePatientUpdatePopup = (props: any) => {
    const dispatch: any = useDispatch();
    const {
        showModal,
        setShowModal,
        handleClose,
        poupDetails,
        afterChangeNotesList,
        patientSearchErrorDescription,
    } = props;
    

    const [buttonLoader, setButtonLoader] = useState<boolean>(false);
    const [showSearchPatientName, setShowSearchPatientName] = useState<string|null>(null);
    const [searchPatientName, setSearchPatientName] = useState<string|null>(null);
    const [searchedDate, setSearchedDate] = useState<string|null>(null);
    const searchPatientList = useSelector(
        (state: any) => state.patientlookUp?.searchPatientList || []
    );
 
    const [mappedPatientDetails, setMappedPatientDetails] = useState<any>({})
 
    // table
    const [loader, setLoader] = useState<boolean>(true);
    const [page, setPage] = useState<number>(1);
    const [totalPage, setTotalPage] = useState<number>(1);
    const [sort, setSort] = useState<string>("lastName");
    const [sortDir, setSortDir] = useState<string>("asc");
    const [limit, ] = useState<number>(15);
    const [encounterDate, setEncounterDate] = useState<any>(null);

    // confirm model
    const [showConfirmModel, setShowConfirmModel] = useState<boolean>(false);
    
    const ConvertDate = (date_string:string) => {
        const isValidFormat: boolean = moment(date_string, "YYYY-MM-DD", true).isValid();
        const formattedDate: string = isValidFormat ? date_string : moment(date_string, ["MM/DD/YYYY", "DD/MM/YYYY"]).format("YYYY-MM-DD");
        return formattedDate
    };
    
    const ConvertOutputDate = (date_string:string) => {
        const isValidFormat: boolean = moment(date_string, "MM/DD/YYYY", true).isValid();
        const formattedDate: string = isValidFormat ? date_string : moment(date_string, ["YYYY-MM-DD", "DD/MM/YYYY"]).format("MM/DD/YYYY");
        return formattedDate
    };

    
    const [, setTotalRecord] = useState<number>(0);
    
    const handlePatientListData = (param:any = {}) => {
        const apiParam = {
            page:page,
            name: searchPatientName,
            sort_by: sort,
            sort_dir: sortDir,
            limit: limit,
            DOB: searchedDate
        }
    if ('page' in param) {
        setPage(param?.page);
        apiParam['page'] = param['page']
    }
    if ('sort' in param) {
        apiParam['sort_by'] = param['sort'];
        apiParam['sort_dir'] = param['sortDir'];
        apiParam['page'] = 1
        setSort(param['sort'])
        setSortDir(param['sortDir'])
        setPage(1)
    }
    if ('DOB' in param) {
        setSearchedDate(param['DOB']);
        apiParam['DOB'] = param['DOB'];
        apiParam['page'] = 1
        setPage(1)
    }
    if ('search' in param) {
        setSearchPatientName(param?.search);
        apiParam['name'] = param['search'];
        apiParam['page'] = 1
        setPage(1)
    }
    if(apiParam['page'] === 1){
        setLoader(true)
    }
    dispatch(
        fetchSearchPatientList(apiParam)
    ).then((res: any) => {
        setTotalPage(res?.payload?.total_pages);
          setTotalRecord(res?.payload?.total_count);
          setLoader(false);
        });
   }

   const handleNextPage = () => {
       handlePatientListData({'page':page + 1});
    };
    
    const setSelectedPatient = (row:any) => {
        setMappedPatientDetails(row)
    }

    const handleBirthDate = (value:string|null) => {
        if(value){
            handlePatientListData({'DOB':value})
        }else{
            handlePatientListData({'DOB':null})
        }
    }

    const updatePatientDetailConfirm = () => {
        if (!encounterDate) {
            toast.error("Date of service is required");
        } else if(poupDetails?.error?.toLowerCase().startsWith(patientSearchErrorDescription)){
            if (mappedPatientDetails?.id) {
                setShowConfirmModel(true)
            } else {
                toast.error("Please update the patient's information");
            }
        } else {
            setShowConfirmModel(true)
        }
    }
    
    const updatePatientDetail = async() => {
        setButtonLoader(true)
        const payload = {
            patient_id: mappedPatientDetails?.id || null,
            encounter_date: encounterDate ? ConvertDate(encounterDate) : null
        }
        await UpdateNotesErrorByPatientDetailsAPI(poupDetails?.id,payload)
        .then(async (res: any) => {
                if (res?.success) {
                  toast.success(res?.message);
                  setButtonLoader(false)
                  handlePatientListData({page:1})
                  setMappedPatientDetails({})
                  setShowConfirmModel(false)
                  setShowModal(false)
                  resetState()
                  afterChangeNotesList()
                } else {
                    toast.error(res?.message || res?.detail?.message || "Update patient details failed");
                    setButtonLoader(false)
                }
              })
    }

    const resetState = () => {
        setSearchedDate(null)
        setShowSearchPatientName(null)
        setSearchPatientName(null)
        setSort('lastName')
        setSortDir('asc')
    }

    const GetMappedPatientDetail = (patient_id:string) => {
        getPatientIdList({patient_id:patient_id}).then((res: any) => {
            if (res?.success) {
                setMappedPatientDetails(res?.result?.data)
            } else {
                toast.error(res?.message || res?.detail?.message || "Get mapped patient details failed");
            }
        })
    }
    
    useEffect(() => {
        if(showModal){
            setEncounterDate(
                poupDetails?.encounter_date ? ConvertDate(poupDetails?.encounter_date) : null
            )
            handlePatientListData({page:1})
            setMappedPatientDetails({})
            if (poupDetails?.patient_id){
                GetMappedPatientDetail(poupDetails?.patient_id)
            }
            setShowConfirmModel(false)
            resetState()
        }
     },[showModal])

     useEffect(() => {
        const handler = setTimeout(() => {
            handlePatientListData({ search: showSearchPatientName });
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [showSearchPatientName]);

    return (
        //eslint-disable-next-line
        //@ts-ignore

        <SidePopup
            showModal={showModal}
            handleClose={handleClose}
            width="max-w-[1200px]"
            title={'Update Notes Details'}
            closeIcon={false}
            footerStyle="flex justify-end gap-[16px] "
            footerContent={ showConfirmModel ? null :(
                    <>
                        <CustomButton
                            buttonStyle="text-[#031227] bg-white hover:bg-[#F5F5F5] disabled:bg-white disabled:text-[#AAADB1]  px-[26px] py-[12px] text-[14px] font-semibold leading-[17px] border-[#E8ECF4] "
                            buttonName="Cancel"
                            primary={false}
                            disable={buttonLoader}
                            onClick={() => {
                                    setShowModal(false);
                            }}
                        />
                        <CustomButton
                            type="submit"
                            loader={buttonLoader}
                            loaderStyle={`px-[40.5px] py-[13px] leading-[17px]`}
                            primary={true}
                            disable={buttonLoader}
                            buttonStyle="text-white px-[36px] py-[12px] text-[14px] font-semibold leading-[17px] hover:bg-[#166B5E] disabled:bg-[#75C8BB]  "
                            buttonName={"Update"}
                            onClick={() => {
                                updatePatientDetailConfirm();
                            }}
                        />
                    </>)
            }
        >
            

            <div
                className="pt-[1px]"
                
            >
                <div className="w-full col-span-1 mb-[2px] grid grid-cols-[49%_49%] gap-1">
                    <div className="h-full p-2 border border-gray-200 rounded-lg shadow-sm">
                        <div className=" font-medium text-center my-2">Notes Details</div>
                        <hr className="my-2 shadow-md" />
                        <div className="grid text-[14px] grid-cols-[20%_30%_20%_30%] gap-y-8px">
                            <div className={`font-medium ${['',null,undefined].includes(poupDetails?.actual_patient_last_name) ? 'bg-red-100' : ''}`}>Last Name :</div>
                            <div className={`max-w-[200px] truncate ${['',null,undefined].includes(poupDetails?.actual_patient_last_name) ? 'bg-red-100' : ''}`} title={poupDetails?.actual_patient_last_name ? WordTitle(poupDetails?.actual_patient_last_name) : ''}>
                        
                                <div>
                                    {WordTitle(poupDetails?.actual_patient_last_name || '')}
                                </div>
                        
                            </div>
                            <div className={`font-medium ${['',null,undefined].includes(poupDetails?.actual_patient_first_name) ? 'bg-red-100' : ''}`}>First Name :</div>
                            <div className={`max-w-[200px] truncate ${['',null,undefined].includes(poupDetails?.actual_patient_first_name) ? 'bg-red-100' : ''}`} title={poupDetails?.actual_patient_first_name ? WordTitle(poupDetails?.actual_patient_first_name) : ''}>
                                <div>
                                    {WordTitle(poupDetails?.actual_patient_first_name || '')}
                                </div>
                            </div>
                            <div className={`font-medium ${['',null,undefined].includes(poupDetails?.actual_DOB) ? 'bg-red-100' : ''}`}>Date of birth :</div>
                            <div className={`max-w-[200px] truncate ${['',null,undefined].includes(poupDetails?.actual_DOB) ? 'bg-red-100' : ''}`} title={poupDetails?.actual_DOB ? poupDetails?.actual_DOB : ''}>{poupDetails?.actual_DOB ? poupDetails?.actual_DOB : ''}</div>
                            <div className={`font-medium ${['',null,undefined].includes(poupDetails?.actual_gender) ? 'bg-red-100' : ''}`}>Gender :</div>
                            <div className={`max-w-[200px] truncate ${['',null,undefined].includes(poupDetails?.actual_gender) ? 'bg-red-100' : ''}`} title={poupDetails?.actual_gender ? WordTitle(poupDetails?.actual_gender) : ''}>{poupDetails?.actual_gender ? WordTitle(poupDetails?.actual_gender) : ''}</div>
                            <div className={`font-medium ${['',null,undefined].includes(poupDetails?.encounter_date) ? 'bg-red-100' : ''}`}>Date of service :</div>
                            <div className={`max-w-[200px] truncate ${['',null,undefined].includes(poupDetails?.encounter_date) ? 'bg-red-100' : ''}`} title={poupDetails?.encounter_date || ''}>{poupDetails?.encounter_date || ''}</div>
                            <div className=" font-medium">Location :</div>
                            <div className=" max-w-[200px] truncate" title={poupDetails?.location ? WordTitle(poupDetails?.location) : ''}>{poupDetails?.location ? WordTitle(poupDetails?.location) : ''}</div>
                            <div className=" font-medium">Sender :</div>
                            <div className=" max-w-[200px] truncate" title={poupDetails?.sender_name ? WordTitle(poupDetails?.sender_name) : ''}>{poupDetails?.sender_name ? WordTitle(poupDetails?.sender_name) : ''}</div>
                            <div className=" font-medium">Error :</div>
                            <div className=" max-w-[200px] truncate" title={poupDetails?.error ? poupDetails?.error : ''}>{poupDetails?.error || ''}</div>
                        </div>
                        
                    </div>
                    <div className="h-full p-2  border border-gray-200 rounded-lg shadow-sm">
                        <div>
                            <div className=" font-medium text-center my-2">Update Notes Details</div>
                            <hr className="my-2 shadow-md" />
                            <div className="text-[14px] grid grid-cols-[20%_30%_20%_30%] gap-y-8px">
                                <div className=" font-medium">Last Name :</div>
                                <div className=" max-w-[200px] truncate" title={mappedPatientDetails?.lastName ? WordTitle(mappedPatientDetails?.lastName) : ''}>
                                    {WordTitle(mappedPatientDetails?.lastName || '')}
                                </div>
                                <div className=" font-medium">First Name :</div>
                                <div className=" max-w-[200px] truncate" title={mappedPatientDetails?.firstName ? WordTitle(mappedPatientDetails?.firstName) : ''}>
                                    {WordTitle(mappedPatientDetails?.firstName || '')}
                                </div>
                                <div className=" font-medium">Date of birth :</div>
                                <div className=" max-w-[200px] truncate" title={mappedPatientDetails?.birthDate ? mappedPatientDetails?.birthDate : ''}>{mappedPatientDetails?.birthDate ? mappedPatientDetails?.birthDate : ''}</div>
                                <div className=" font-medium">Gender :</div>
                                <div className=" max-w-[200px] truncate" title={mappedPatientDetails?.gender ? WordTitle(mappedPatientDetails?.gender) : ''}>{WordTitle(mappedPatientDetails?.gender ? mappedPatientDetails?.gender : '')}</div>
                                <div className="col-span-4">
                                    <div className="grid grid-cols-[20%_70%]">
                                        <div className="font-medium h-full flex items-center">Date of service :</div>
                                        <TextIconInput
                                            divStyle="mt-[2px] p-1"
                                            minLength={4}
                                            placeholder="Date of service"
                                            maxLength={50}
                                            inputStyle=" !p-2"
                                            name="date_of_service"
                                            id="date_of_service"
                                            value={encounterDate || ''}
                                            errors={encounterDate ? false : true}
                                            onChange={(e: any) => {
                                                setEncounterDate(e.target.value);
                                            }}
                                            type={"date"}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="w-full col-span-1 mb-[2px] grid grid-cols-[49%_49%] gap-1 mt-3">
                    
                    <TextIconInput
                        placeholder="search patient name"
                        divStyle=""
                        onChange={(e: any) => {
                            if (setShowSearchPatientName) setShowSearchPatientName(e.target.value);
                        }}
                        inputStyle="w-full border-[#E8ECF4] border-[0.5px] rounded-[8px] !h-[48px]"
                        icon={SearchIcon}
                        value={showSearchPatientName?showSearchPatientName:''}
                        setShowSearch={setShowSearchPatientName}
                        clearSearch={()=>{
                            setShowSearchPatientName('')
                        }}
                        iconStyle="w-[18px] h-[18px] bottom-[12px] right-[10px] border-none rounded-[0px]"
                    />

                    <TextIconInput
                        divStyle=""
                        minLength={4}
                        placeholder="Patient date of brith"
                        maxLength={50}
                        name="DOB"
                        id="DOB"
                        inputStyle=" !h-[48px]"
                        value={searchedDate?searchedDate:''}
                        onChange={(e: any) => {
                            handleBirthDate(e.target.value);
                        }}
                        type={"date"}
                    />
                    <div className="col-span-2">
                        <Table
                            loading={loader}
                            data={searchPatientList}
                            tableScroll={"100%"}
                            tableHeight={450}
                            sort={true}
                            Clickable={true}
                            pageSecondTableIndentifyClass="patientUpdateScrollableDiv"
                            rowClick={(row: any) => {
                            setSelectedPatient(row)
                            }}
                            hasNextPage={page < totalPage}
                            NextPageData={handleNextPage}
                            columns={[
                            "Last Name",
                            "First Name",
                            "DOB",
                            "Gender"
                            ]}
                            sortTitleKeys={{
                            "Last Name": "lastName",
                            "First Name": "firstName",
                            "Gender": "gender",
                            }}
                            handleSortfunc={(key: any, value: any) => {
                                handlePatientListData({'sort':key,'sortDir':value})
                            }}
                            rowSpecificClass={(row: any) => row?.id === mappedPatientDetails?.id ? ' bg-[#EDF8F9] hover:!bg-[#d1f0ea]' : ''}
                            scopedSlots={{
                                "Last Name": ({ row }: any) => (
                                <td title={WordTitle(row?.lastName)}>
                                    <div className=" max-w-[500px] truncate cursor-pointer">
                                    {WordTitle(row?.lastName)}
                                    </div>
                                </td>
                                ),
                                "First Name": ({ row }: any) => (
                                <td title={WordTitle(row?.firstName)}>
                                    <div className=" max-w-[500px] truncate cursor-pointer">
                                    {WordTitle(row?.firstName)}
                                    </div>
                                </td>
                                ),
                                "DOB": ({ row }: any) => (
                                <td title={row?.birthDate || ""}>
                                    <div className=" max-w-[500px] truncate cursor-pointer">
                                    {row?.birthDate}
                                    </div>
                                </td>
                                ),
                                Gender: ({ row }: any) => (
                                <td title={row?.gender || ""}>
                                    <div className=" max-w-[500px] truncate cursor-pointer">
                                    {WordTitle(row?.gender)}
                                    </div>
                                </td>
                                ),
                                "Location": ({ row }: any) => (
                                <td title={row?.location || ""}>
                                    <div className=" max-w-[500px] truncate cursor-pointer">
                                    {WordTitle(row?.location)}
                                    </div>
                                </td>
                                )
                            }}
                        />
                    </div>
                </div>
                <ConfirmPopup showModal={showConfirmModel} icon>
                    <div className="text-[16px] font-semibold text-center text-[#061018] line-height-[24px]">
                    Update notes details?
                    </div>
                    <div className="text-[12px] font-normal text-center text-[#061018] mt-[8px] mb-[16px] ">
                    <div className="grid grid-cols-[30%_max-content_max-content] gap-y-10px  text-left">
                        {  mappedPatientDetails?.id &&
                        <>
                            <div className={`font-medium ${['',null,undefined].includes(poupDetails?.actual_patient_last_name) ? 'bg-red-100' : ''}`}>Last Name :</div>
                            <div className={`max-w-[200px] truncate ${['',null,undefined].includes(poupDetails?.actual_patient_last_name) ? 'bg-red-100' : ''}`}>
                                {WordTitle(poupDetails?.actual_patient_last_name || '')}
                            </div>
                            <div className={`max-w-[200px] truncate ${['',null,undefined].includes(poupDetails?.actual_patient_last_name) ? 'bg-red-100' : ''}`}>
                                <span className={`font-semibold mx-2 ${['',null,undefined].includes(poupDetails?.actual_patient_last_name) ? 'bg-red-100' : ''}`}>to</span> {WordTitle(mappedPatientDetails?.lastName || '')}
                            </div>
                            <div className={`font-medium ${['',null,undefined].includes(poupDetails?.actual_patient_first_name) ? 'bg-red-100' : ''}`}>First Name :</div>
                            <div className={`max-w-[200px] truncate ${['',null,undefined].includes(poupDetails?.actual_patient_first_name) ? 'bg-red-100' : ''}`}>
                                {WordTitle(poupDetails?.actual_patient_first_name || '')}
                            </div>
                            <div className={`max-w-[200px] truncate ${['',null,undefined].includes(poupDetails?.actual_patient_first_name) ? 'bg-red-100' : ''}`}>
                                <span className={`font-semibold mx-2 ${['',null,undefined].includes(poupDetails?.actual_patient_first_name) ? 'bg-red-100' : ''}`}>to</span> {WordTitle(mappedPatientDetails?.firstName || '')}
                            </div>
                            <div className={`font-medium ${['',null,undefined].includes(poupDetails?.actual_DOB) ? 'bg-red-100' : ''}`}>Date of birth :</div>
                            <div className={`max-w-[200px] truncate ${['',null,undefined].includes(poupDetails?.actual_DOB) ? 'bg-red-100' : ''}`}>{poupDetails?.actual_DOB ? poupDetails?.actual_DOB : ''}</div>
                            <div className={`max-w-[200px] truncate ${['',null,undefined].includes(poupDetails?.actual_DOB) ? 'bg-red-100' : ''}`}> <span className={`font-semibold mx-2 ${['',null,undefined].includes(poupDetails?.actual_DOB) ? 'bg-red-100' : ''}`}>to</span> {mappedPatientDetails?.birthDate ? mappedPatientDetails?.birthDate : ''}</div>
                            <div className={`font-medium ${['',null,undefined].includes(poupDetails?.actual_gender) ? 'bg-red-100' : ''}`}>Gender :</div>
                            <div className={`max-w-[200px] truncate ${['',null,undefined].includes(poupDetails?.actual_gender) ? 'bg-red-100' : ''}`}>{WordTitle(poupDetails?.actual_gender ? poupDetails?.actual_gender : '')}</div>
                            <div className={`max-w-[200px] truncate ${['',null,undefined].includes(poupDetails?.actual_gender) ? 'bg-red-100' : ''}`}> <span className={`font-semibold mx-2 ${['',null,undefined].includes(poupDetails?.actual_gender) ? 'bg-red-100' : ''}`}>to</span> {WordTitle(mappedPatientDetails?.gender ? mappedPatientDetails?.gender : '')}</div>
                        </>
                        }
                        <div className={`font-medium ${['',null,undefined].includes(poupDetails?.encounter_date) ? 'bg-red-100' : ''}`}>Date of service :</div>
                        <div className={`max-w-[200px] truncate ${['',null,undefined].includes(poupDetails?.encounter_date) ? 'bg-red-100' : ''}`}>{poupDetails?.encounter_date ? poupDetails?.encounter_date : ''}</div>
                        <div className={`max-w-[200px] truncate ${['',null,undefined].includes(poupDetails?.encounter_date) ? 'bg-red-100' : ''}`}> <span className={`font-semibold mx-2 ${['',null,undefined].includes(poupDetails?.encounter_date) ? 'bg-red-100' : ''}`}>to</span> {encounterDate ? ConvertOutputDate(encounterDate) : ''}</div>
                    </div>
                    <div className="mt-2">
                        Are you sure you want to continue?
                    </div>
                    </div>
                    <div className="flex justify-center gap-[16px] items-center w-full">
                    <CustomButton
                        buttonName="Cancel"
                        primary={false}
                        buttonStyle="w-full text-[#1C252D] text-[14px] p-[12px] text-[14px] font-semibold leading-[17px] hover:bg-gray-200  "
                        disable={buttonLoader}
                        onClick={() => {
                        setShowConfirmModel(false);
                        }}
                    />
                    <CustomButton
                        buttonName="Yes"
                        primary={true}
                        buttonStyle="w-full text-white  hover:bg-[#166B5E] text-[14px] p-[12px] text-[14px] font-semibold leading-[17px]   "
                        loader={buttonLoader}
                        disable={buttonLoader}
                        loaderStyle="w-full bg-[#F5F5F5]/80  py-[13px] "
                        onClick={() => {
                            updatePatientDetail()
                            setShowConfirmModel(false)
                        }}
                    />
                    </div>
                </ConfirmPopup>
            </div>

        </SidePopup>
        
    );
};
